<template>
  <BaseModal>
    <div class="confirm-modal-wrapper">
        <img src="/icons/qr-white-logo.svg" class="qr-logo">
        <br>
        <slot>{{ $t('confirm_modal.default') }}</slot>
        <br>
        <div class="confirm-modal-buttons">
            <DashboardButton variant="danger" @click="onConfirm">
                {{ $t('confirm_modal.confirm') }}
            </DashboardButton>
            <DashboardButton variant="success" @click="onCancel">
                {{ $t('confirm_modal.cancel') }}
            </DashboardButton>
        </div>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from './BaseModal.vue'
import DashboardButton from "@/components/DashboardButton.vue"

export default {
    components: {
        BaseModal,
        DashboardButton
    },
    methods: {
        onConfirm() {
            this.$emit('confirm');
        },
        onCancel() {
            this.$emit('cancel');
        }
    }
}
</script>

<style scoped>
.confirm-modal-wrapper {
    text-align: center;
}

.qr-logo {
    width: 3.33vw;
    height: 3.33vw;
    margin-bottom: 3.33vw;
    margin-top: 1.33vw;
}

.sure {
    font-weight: 500;
    font-size: 1.06vw;

    color: #EDEDED;
}

.confirm-modal-buttons {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 3vw;
}


.last-button {
    margin-left: 2vw;
}
</style>
